import { selectAvaTranslateManager } from '../selectors/avaTranslate';
import { useAppSelector } from '../store/store';
export default function useAvaTranslateManager() {
    const avaTranslateManager = useAppSelector(selectAvaTranslateManager);
    return avaTranslateManager;
}
